import { Component } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { NeighborhoodService } from '../../../../services/neighborhood.service';

@Component({
  selector: 'app-general-page',
  templateUrl: './general-page.component.html',
  styleUrl: './general-page.component.scss'
})
export class GeneralPageComponent {

  constructor(
    public authService: AuthService,
    public neighborhoodService: NeighborhoodService
  ) {}

  update() {
    this.neighborhoodService.update();
  }

}
